import { createContext } from "react";

const requestsContext = createContext();

export default requestsContext;
